import { apiPost } from './client.js';

export const login = ({ email, password }) => apiPost('/auth/login', { email, password });
export const logout = () => apiPost('/auth/logout', {});
